export const REGEX_ALPHABETICAL_OR_NUMERIC = /^[a-zA-Z0-9]+$/;
export const REGEX_BITCOIN_WALLET_ADDRESS = /^(bc1|[13])[a-zA-HJ-NP-Z0-9]{25,39}$/;
export const REGEX_EMAIL = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/;
export const REGEX_NUMERIC = /\d+/;
export const REGEX_PHONE_NUMBER = /^\d{6,10}$/;
export const REGEX_PHONE_WITH_AREA_CODE = /^\+?\d+$/;
export const REGEX_TETHER_WALLET_ADDRESS = /T[A-Za-z1-9]{33}/;
export const REGEX_SOLANA_WALLET_ADDRESS = /^[1-9A-HJ-NP-Za-km-z]{32,44}$/;
export const REGEX_ETHEREUM_WALLET_ADDRESS = /^0x[a-fA-F0-9]{40}$/;
